export const universalSchedulerDefaults = {
  scheduler: {
    title: 'Accounting for Everything',
    sub_title:
      'Nationwide tax and accounting services for small businesses, provided by local CPAs.',
    additional_copy:
      'Choose the best time, provide some basic info, and we’ll give you a call.',
    accountant_details: {
      image: {
        url: '/images/Susan_Young_color.png',
        alt: 'Susan Young headshot',
      },
      name: 'Susan Young',
      job_title: '1-800Accountant Specialist',
    },
    paid_campaign: true,
    is_stimulus: false,
  },
  form: {
    lead_source: '1-800Accountant',
    lead_type: 'Join Now',
    title: 'Great! We need a little more information to schedule your appointment.',
    service_type: 'Accounting',
    button_text: 'Confirm My Appointment',
  },
  thank_you: {
    title: 'Talk To You Soon!',
    sub_title:
      "Your appointment is scheduled and confirmed. We'll also send a confirmation email with this info for your convenience.",
    calendar_event_title: 'Accounting Consultation',
    calendar_event_description: '',
  },
};
